"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.SubHeading=exports.ModalContainer=exports.ButtonsContainer=void 0;const ModalContainer=exports.ModalContainer=_styledComponents.default.div`
 min-width: 250px;
  height: content-fit;
  text-align: left;
  max-width: 375px;
  max-height: 375px;
  padding: 8px;

  .fsaCardtext{
    line-height: 32px;
  }

  .subheading-container{
    display: flex;
    align-items: center;
  }
`,ButtonsContainer=exports.ButtonsContainer=_styledComponents.default.div`
display:flex;
flex-direction: row;
justify-content:flex-end;
align-items:center;
margin-left: 30%;
 `,SubHeading=exports.SubHeading=_styledComponents.default.p`
 font-size: 20px;
 font-weight: 600;
 font-size: 20px;
 line-height: 32px;
 color: #330A0B;
 width: 90%;
 align-items: center;
 `;